import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Box
} from '@mui/material';
import { format, isSameDay, isAfter, isBefore, startOfWeek, endOfWeek } from 'date-fns';
import { ptBR } from 'date-fns/locale';

const BirthdayGrid = ({ birthdays }) => {
  const today = new Date();
  // Define o início da semana como segunda-feira (1) e o final como domingo
  const startOfCurrentWeek = startOfWeek(today, { weekStartsOn: 1 });
  const endOfCurrentWeek = endOfWeek(today, { weekStartsOn: 1 });

  const formatBirthdayLine = (birthday) => {
    const birthdayDate = new Date(birthday.birthday);
    // Ajusta para o fuso horário local
    birthdayDate.setMinutes(birthdayDate.getMinutes() + birthdayDate.getTimezoneOffset());
    
    // Cria uma data para comparação apenas com mês e dia (ano atual)
    const currentYear = today.getFullYear();
    const birthdayThisYear = new Date(currentYear, birthdayDate.getMonth(), birthdayDate.getDate());
    
    const formattedDate = format(birthdayDate, 'dd/MM', { locale: ptBR });
    const isToday = isSameDay(birthdayThisYear, today);
    
    // Verifica se o aniversário já passou esta semana, é hoje, ou ainda vai ocorrer
    let emoji;
    if (isToday) {
      emoji = '🎂'; // Aniversário hoje
    } else if (isBefore(birthdayThisYear, today) && isAfter(birthdayThisYear, startOfCurrentWeek)) {
      emoji = '✅'; // Aniversário já passou esta semana
    } else if (isAfter(birthdayThisYear, today) && isBefore(birthdayThisYear, endOfCurrentWeek)) {
      emoji = '⌛'; // Aniversário ainda vai ocorrer esta semana
    } else {
      // Não deveria cair aqui se os dados estiverem filtrados corretamente para a semana atual
      emoji = '📅';
    }
    
    let line = `${formattedDate} - ${birthday.name}`;
    if (birthday.nickname) {
      line += ` (${birthday.nickname})`;
    }
    if (birthday.funcao) {
      line += ` - ${birthday.funcao}`;
    }
    line += ` - ${birthday.idade} anos`;

    return { text: line, isToday, emoji };
  };

  return (
    <Card>
      <CardHeader title="Aniversários" />
      <CardContent>
        {birthdays && birthdays.length > 0 ? (
          birthdays.map((birthday, index) => {
            const { text, isToday, emoji } = formatBirthdayLine(birthday);
            return (
              <Box key={index} sx={{ mb: 1 }}>
                <Typography 
                  variant="body1" 
                  sx={{ 
                    fontWeight: isToday ? 'bold' : 'normal',
                    '&:last-child': { mb: 0 }
                  }}
                >
                  {emoji} {text}
                </Typography>
              </Box>
            );
          })
        ) : (
          <Typography variant="body1" color="textSecondary">
            Infelizmente não há pessoas fazendo aniversário essa semana... :(
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default BirthdayGrid;
